import React from "react";
import "./IGBCPressRelease.css";
import plaqueEvent from "../assets/igbc-plaque-event.jpeg";
import lakshmiVenu from "../assets/lakshmi-venu.jpeg";

function IGBCPressRelease() {
  return (
    <section className="press-release-container">
      <img
        src={plaqueEvent}
        alt="Sundaram-Clayton IGBC Platinum Plaque presentation"
        className="press-main-image"
      />

      <h1>
        Sundaram-Clayton Limited's Thervoy Kandigai Plant Achieves IGBC
        Platinum Rating for Green Building
      </h1>
      <p className="press-location">Chennai, India</p>

      <p>
        Sundaram-Clayton Limited, one of India's leading automotive component
        manufacturers, announced that its Thervoy Kandigai Plant has been
        awarded the prestigious IGBC Platinum Rating by the Indian Green
        Building Council (IGBC). The certification recognizes the plant's
        outstanding commitment to sustainable manufacturing, resource
        efficiency, and environmental stewardship.
      </p>

      <p>
        The IGBC Platinum Rating, awarded under the Green Building
        certification framework, is the highest level of recognition for
        facilities demonstrating excellence in energy efficiency, water
        conservation, sustainable infrastructure, waste management, and
        occupant well-being. Thervoy Kandigai Plant achieved this significant
        milestone, reflecting Sundaram-Clayton's commitment to integrating
        sustainability into its business operations and supporting India's
        transition towards a greener future.
      </p>

      <p>
        Commenting on this achievement, <strong>Dr. Lakshmi Venu, Managing
        Director</strong>, Sundaram-Clayton Limited, stated:
      </p>

      <p className="press-quote-wrap">
        <img
          src={lakshmiVenu}
          alt="Dr. Lakshmi Venu, Managing Director, Sundaram-Clayton Limited"
          className="press-person-image"
        />
        <em>
          "We are delighted to receive the IGBC Platinum Rating for our
          Thervoy Kandigai Plant. SCL is passionate about implementing
          world-class sustainability initiatives across our facilities.
          Through continuous innovation, renewable energy adoption, efficient
          resource utilization, and environmental responsibility, we are
          building a future-ready manufacturing ecosystem that aligns with
          our vision of sustainable growth."
        </em>
      </p>

      <div style={{ clear: "both" }} />

      <p>
        The facility's sustainable practices lead to tangible benefits. These
        include reduced resource dependency, cost optimisation, and a better
        workplace environment.
      </p>

      <p>
        <em>
          "The Thervoy Kandigai Plant represents our commitment to
          operational excellence and sustainable manufacturing. The IGBC
          Platinum certification validates the significant actions taken
          towards energy efficiency, water conservation, renewable energy,
          and environmentally responsible infrastructure. We will continue
          to strengthen our sustainability initiatives while delivering
          world-class products and creating value for all stakeholders."
        </em>{" "}
        said Mr. R. Venkatesh, Director &amp; Chief Executive Officer,
        Sundaram-Clayton Limited.
      </p>

      <h2 className="press-h2">Key Highlights:</h2>
      <ul>
        <li>
          Water Stewardship: The plant has implemented an
          8,000 KL rainwater harvesting system and achieves 95% water reuse
          through efficient treatment and recycling systems.
        </li>
        <li>
          Zero Liquid Discharge: The facility operates with
          advanced water treatment system and follows Zero Liquid Discharge
          (ZLD) principles, ensuring responsible water management and
          environmental protection.
        </li>
        <li>
          Sustainable Infrastructure: The plant incorporates
          natural daylight utilization, energy-efficient LED lighting,
          optimized ventilation systems, fossil fuel free canteen,
          sustainable landscaping, and environmentally responsible
          operational practices.
        </li>
        <li>
          Renewable Energy Integration: The facility is
          powered by 100% renewable energy and features a 4.2 MW rooftop
          solar installation, contributing significantly to the plant's
          clean energy requirements.
        </li>
        <li>
          Employee Well-being: Enhanced indoor environmental
          quality and green infrastructure contribute to a safe, healthy, and
          productive workplace.
        </li>
      </ul>

      <p>
        The Thervoy Kandigai Plant stands as a testament to Sundaram-Clayton
        Limited's commitment to sustainability, innovation, and operational
        excellence. The IGBC Platinum Rating further strengthens the
        company's vision of building a cleaner, greener, and more sustainable
        future.
      </p>

      <p>
        The Thervoy Kandigai Plant, commissioned in 2024, has been designed
        in line with global sustainability standards and represents a
        benchmark in environmentally responsible manufacturing. Spread across
        a 50-acre campus with a built-up area of 76,000 square metres, the
        facility integrates advanced green building concepts and sustainable
        operational practices.
      </p>
    </section>
  );
}

export default IGBCPressRelease;